"use client";

import * as React from "react";
import { Text, SectionCard, CardTitle, CardDescription, Section, RangeCalendar } from "@/src/components";
import { DateRange } from "react-day-picker";
import { addDays } from "date-fns";
import { InstallCommand } from "@/components/docs/install-command";

export default function DocsComponentsRangeCalendar() {
  const [range, setRange] = React.useState<DateRange | undefined>({
    from: new Date(),
    to: addDays(new Date(), 7),
  });
  return (
    <>
      <Section>
        <div className="space-y-4">
          <Text as="h1" className="text-h2 font-bold">
            Range Calendar
          </Text>
          <Text className="text-lg text-muted-foreground max-w-2xl">
            A calendar component for selecting date ranges with start and end dates.
          </Text>
        </div>
      </Section>

      {/* Installation */}
      <Section>
        <SectionCard
          header={
            <>
              <CardTitle>Installation</CardTitle>
              <CardDescription>Add this component to your project</CardDescription>
            </>
          }
          contentClassName="p-6"
        >
          <InstallCommand command="npx shadcn@latest add @bluecopa-ui/range-calendar" />
        </SectionCard>
      </Section>

      <Section>
        <SectionCard
          header={
            <>
              <CardTitle>Example</CardTitle>
              <CardDescription>Select a date range</CardDescription>
            </>
          }
          contentClassName="p-6"
        >
          <div className="flex justify-center">
            <RangeCalendar
              selected={range}
              onSelect={setRange}
              className="rounded-md border"
            />
          </div>
        </SectionCard>
      </Section>

      <Section>
        <SectionCard
          header={<CardTitle>Props</CardTitle>}
          contentClassName="p-6"
        >
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b">
                <th className="text-left py-2 font-semibold">Prop</th>
                <th className="text-left py-2 font-semibold">Type</th>
                <th className="text-left py-2 font-semibold">Description</th>
              </tr>
            </thead>
            <tbody>
              <tr className="border-b">
                <td className="py-2 font-mono text-xs">selected</td>
                <td className="py-2 font-mono text-xs text-muted-foreground">DateRange</td>
                <td className="py-2 text-muted-foreground">Selected date range (from/to)</td>
              </tr>
              <tr className="border-b">
                <td className="py-2 font-mono text-xs">onSelect</td>
                <td className="py-2 font-mono text-xs text-muted-foreground">function</td>
                <td className="py-2 text-muted-foreground">Selection change handler</td>
              </tr>
              <tr className="border-b">
                <td className="py-2 font-mono text-xs">numberOfMonths</td>
                <td className="py-2 font-mono text-xs text-muted-foreground">number</td>
                <td className="py-2 text-muted-foreground">Number of months to display</td>
              </tr>
            </tbody>
          </table>
        </SectionCard>
      </Section>
    </>
  );
}
